<template>
   <div class="container">
     <div class="row">
       <div class="col">
          <img class="imgHome" src="../assets/img/home_logo.png">
        </div>
    </div>    
   </div>
</template>

<script>
// @ is an alias to /src
import axios from "axios";
import router from '../router/index.js'

export default {
  name: 'home',
  mounted() {
    //Config for axios
    axios.defaults.headers.common['access-token'] = this.$store.state.token;

    axios.interceptors.response.use(function (response){
        if (response.data.message == 'Token inválida') {
            router.push({name: 'login', params: {errorToken: 'true'}});
        }else{
            return response;
        }
    }, function(error){
      if(error){
        //console.log(error);
      }
        
    });
    //End config for axios
  }
}
</script>
<style scoped>
    .imgHome{
      width: 70%;
      height:70%;
  }
    .row{
      align-content:center;
      padding-top: 180px;
      position: relative;
      margin-top: 30px;
      margin-left: 300px;
    }
</style>
